import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HTTP_INTERCEPTORS
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // add JWT auth header if a user is logged in for API requests
    const accessTokenData = localStorage.getItem('v0.0.1-accessToken');

    if (accessTokenData) {
      const {accessToken, refreshToken} = JSON.parse(accessTokenData);

      const isApiUrl = request.url.startsWith(environment.apiUrl);
      if (isApiUrl) {
        if (request.url.endsWith('/refresh')) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${refreshToken}` },
            body: { refreshToken }, // Add refreshToken to the request body
          });
        } else if (accessToken) {
          // For regular API requests, add accessToken to headers
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${accessToken}` },
          });
        }
      }
    }


    return next.handle(request);
  }
}

export const JwtInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true
  }
]
